import { render, staticRenderFns } from "./ExamIndexBread.vue?vue&type=template&id=196df0e2"
import script from "./ExamIndexBread.vue?vue&type=script&lang=js"
export * from "./ExamIndexBread.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports